import { createStyleSheet } from '@shared-ui/theme'
import { rf, rh } from '@shared-ui/theme/scale'

export const useCreateStyles = createStyleSheet((theme) => ({
  h1: {
    lineHeight: rf(28.8),
    marginBottom: rh(10),
  },
  h2: {
    lineHeight: rf(21.6),
    marginBottom: rh(10),
  },
  defaultText: {
    fontSize: rf(14),
    color: theme.COLOR_TEXT_PRIMARY,
  },
  secondaryColor: {
    color: theme.COLOR_TEXT_SECONDARY,
  },
  primaryColor: {
    color: theme.COLOR_TEXT_BRAND,
  },
  dangerColor: {
    color: theme.COLOR_TEXT_CRITICAL,
  },
  warningColor: {
    color: theme.COLOR_TEXT_WARNING,
  },
  successColor: {
    color: theme.COLOR_TEXT_SUCCESS,
  },
}))
